import React, { Component } from "react";
import { connect } from "react-redux";
import * as menu from "../../reducers/menuReducer";
import * as modal from "../../reducers/modalReducer";
import * as page from "../../reducers/pageReducer";
import * as userReducer from "../../reducers/userReducer";
import {
  enableScroll,
  disableScroll,
  enableScrollJs,
  disableScrollJs
} from "../../helpers/scroll";
import {
  goBack,
  push,
} from 'connected-react-router';
import {
  filterUri,
  myaccountUri,
  rootPageUri,
  ordersUri,
  addressesUri,
  helpUri,
  notificationUri
} from "../../config/uri";
import styled from "styled-components";
import Page from "../Page";
import { CloseIcon } from "../../icons";
import AccountIcon from "../../icons/AccountIcon";
import LoginIcon from '../../icons/LoginIcon';
import OrdersIcon from "../../icons/OrdersIcon";
import "./style.css";
import {isKioskCustomerSelector} from '../../selectors/userSelectors';
import {isKioskMode as isKioskSelector} from '../../selectors/viewSelectors';
import { BUTTON_GREEN, LIGHT_GREY, DARK_GREY, TRANSPARENT_BACKGROUND } from "../../config/colors";
import ShopIcon from "../../icons/ShopIcon";
import ContactIcon from "../../icons/ContactIcon";
import { 
  isPhoneSelector, 
  getCollections, 
  isEcommerceCollectionBarEnabled 
} from "../../selectors/configSelectors";
import { getSelectedCustomerType } from '../../selectors/customer_type_selector';
import { TREEZ_ASSETS_URL } from '../../const/app_const';
import { getCollectionSearchQueryUrl } from '../../helpers/searchBarHelper';
import { pushWithQueryParams } from "../../services/uri";

const styles = {
  closeBtn: {
    position: "absolute",
    right: "15px",
    top: "15px",
    cursor: "pointer",
    zIndex: "10"
  },
  closeIcon: { height: "35px", width: "35px" },
  menuContainer: { marginTop: 64, zIndex: 2 },
  menuContainerMobile: { marginTop: 48, zIndex: 2 },
};

const ICON_STYLE = {
  height: '22px',
  width: 'auto',
};

class Menu extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.isUser !== nextProps.isUser ||
      this.props.isMenuOpened !== nextProps.isMenuOpened ||
      this.props.modalType !== nextProps.modalType
    );
  }

  componentWillMount() {
    disableScroll();
    disableScrollJs();
    // for navigation porpuses, emulate page opening
    window.history.pushState("forward", null, "");
  }

  componentWillUnmount() {
    enableScroll();
    enableScrollJs();
  }

  getMenuContainerStyle = () => {
    const {
      isPhone,
    } = this.props;

    return isPhone ? styles.menuContainerMobile : styles.menuContainer;
  }

  searchCollections = (collectionId) => {
    this.props.push(getCollectionSearchQueryUrl(collectionId));
    this.props.hideMenu();
  }

  handleLoginClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.props.openLoginForm();
    this.props.hideMenu();
  };
  handleLogOutClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.props.openLogOutForm({
      onClose: this.openMainPage
    });
  };
  openMainPage = () => {
    this.props.hideDetail();
    this.props.go(rootPageUri);
  };
  handleLocationClick = e => {
    if (this.props.isEcommerceEnabled) {
      this.props.hideDetail();
      this.props.hideMenu();
      this.props.openShippingForm();
    }
  };
  hideMenu = () => {
    this.props.hideMenu();
  };
  handleHelpClick = e => {
    e.stopPropagation();
    this.props.hideDetail();
    e.nativeEvent.stopImmediatePropagation();
    // this.props.openHelp();
    this.props.hideMenu();
    this.props.go(helpUri);
  };
  handleOrdersClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.props.hideDetail();
    if (this.props.isUser) {
      this.props.hideMenu();
      this.props.go(ordersUri);
    } else {
      this.props.openLoginForm();
    }
  };
  handleAccountClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.props.hideDetail();
    if (this.props.isUser) {
      this.props.hideMenu();
      this.props.go(myaccountUri);
      // this.props.openAccount();
    } else {
      this.props.openLoginForm();
    }
  };
  handleNotificationsClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    // this.props.openNotifications();
    this.props.hideMenu();
    this.props.go(notificationUri);
  };
  isModalOpen = () => {
    return this.props.modalType != null;
  };
  handleAddressesClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (this.props.isUser) {
      this.props.hideMenu();
      this.props.go(addressesUri);
    } else {
      this.props.openLoginForm();
    }
  };

  handleRefineClick = () => {
    this.props.hideMenu();
    this.props.openFilter();
  };

  renderUpdated() {
    if (!this.props.updated) return null;
    return <div className="updated">&nbsp;</div>;
  }

  onClose = (e) => {
    if (e.target.className !== 'main-menu') {
      this.props.hideMenu()
    }
  }

  isCollectionList = () => {
    const { isPhone, isEcommerceCollectionBarEnabled } = this.props;
    return isPhone && isEcommerceCollectionBarEnabled;
  }

  render() {
    const {
      isUser,
      isKioskCustomer,
      isPhone,
      collections
    } = this.props;

    return (
      <Page
        style={this.getMenuContainerStyle()}
        overlayTop={0}
        closeOnOutsideClick={false}
        isOpened
        onClose={this.onClose}
        background={TRANSPARENT_BACKGROUND}
      >
        <div className="main-menu">
          <div className="arrow-up"></div>
          <div className="main-menu-container">
            {isPhone && (
              <div onClick={this.hideMenu} style={styles.closeBtn}>
                <CloseIcon color={LIGHT_GREY} style={styles.closeIcon} />
              </div>
            )}

            {!isUser && (
              <div
                onClick={e => this.handleLoginClick(e)}
                className="main-menu-item"
              >
                <div className="main-menu-img-wrapper">
                  <LoginIcon style={ICON_STYLE} color={BUTTON_GREEN} />
                </div>
                <span className="main-menu-title">Login/Sign Up</span>
              </div>
            )}

            {!isKioskCustomer &&
            <div
              className="main-menu-item"
              onClick={e => this.handleOrdersClick(e)}
            >
              <div className="main-menu-img-wrapper">
                {isUser && (
                  <OrdersIcon style={ICON_STYLE} color={BUTTON_GREEN} />
                )}
                {!isUser && (
                  <OrdersIcon style={ICON_STYLE} color={BUTTON_GREEN} />
                )}
              </div>
              {isUser && <ItemTitleSpanStyled>Orders</ItemTitleSpanStyled>}
              {!isUser && (
                <ItemTitleSpanStyled disabled>Orders</ItemTitleSpanStyled>
              )}
              {this.renderUpdated()}
            </div>
            }

            {/* {!isKiosk &&
            <div
              onClick={e => this.handleLocationClick(e)}
              className="main-menu-item"
            >
              <div className="main-menu-img-wrapper">
                {this.props.isEcommerceEnabled && (
                  <LocationIcon style={ICON_STYLE} color={BUTTON_GREEN} />
                )}
                {!this.props.isEcommerceEnabled && (
                  <LocationIcon style={ICON_STYLE} color={BUTTON_GREEN} />
                )}
              </div>
              <span className="main-menu-title">Location</span>
            </div>
            } */}

            {!isKioskCustomer &&
            <div
              onClick={e => this.handleAccountClick(e)}
              className="main-menu-item"
            >
              <div className="main-menu-img-wrapper">
                {isUser && (
                  <AccountIcon style={ICON_STYLE} color={BUTTON_GREEN} />
                )}
                {!isUser && (
                  <AccountIcon style={ICON_STYLE} color={BUTTON_GREEN} />
                )}
              </div>
              {isUser && <ItemTitleSpanStyled>Account</ItemTitleSpanStyled>}
              {!isUser && (
                <ItemTitleSpanStyled disabled>Account</ItemTitleSpanStyled>
              )}

            </div>
            }


            <div
              onClick={e => this.openMainPage()}
              className="main-menu-item"
            >
              <div className="main-menu-img-wrapper">
                <ShopIcon style={ICON_STYLE} color={BUTTON_GREEN} />
              </div>
              <span className="main-menu-title">Shop</span>
            </div>

            {this.isCollectionList() && (
              <React.Fragment>
                <hr className="menu-border"></hr>

                {collections.map(c => (
                  <div onClick={e => this.searchCollections(c.id)} className="main-menu-item">
                    <div className="main-menu-img-wrapper">
                      <img src={`${TREEZ_ASSETS_URL}/${c.icon}`} />
                    </div>
                    <span className="main-menu-title">{c.name}</span>
                  </div>
                ))}
                
              </React.Fragment>
            )}

            <hr className="menu-border"></hr>

            <div
              onClick={e => this.handleHelpClick(e)}
              className="main-menu-item"
            >
              <div className="main-menu-img-wrapper">
                <ContactIcon style={ICON_STYLE} color={BUTTON_GREEN} />
              </div>
              <span className="main-menu-title">Contact Us</span>
            </div>

            {isUser && (
              <div
                onClick={e => this.handleLogOutClick(e)}
                className="main-menu-item"
              >
                <div className="main-menu-img-wrapper">
                  <LoginIcon style={ICON_STYLE} color={BUTTON_GREEN} />
                </div>
                <span className="main-menu-title">Log Out</span>
              </div>
            )}

            <div className="main-menu-item main-menu-item-hidden">
              <div className="main-menu-img-wrapper" />
            </div>
          </div>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    isEcommerceEnabled: state.config.isEcommerceEnabled,
    isUser: userReducer.isUser(state),
    modalType: state.modal.modalType,
    isMenuOpened: menu.isMenuOpened(state),
    updated: state.orders.updated,
    isKioskCustomer: isKioskCustomerSelector(state),
    isKiosk: isKioskSelector(state),
    isPhone: isPhoneSelector(state),
    collections: getCollections(state),
    customerType: getSelectedCustomerType(state),
    isEcommerceCollectionBarEnabled: isEcommerceCollectionBarEnabled(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideMenu: () => dispatch(page.hidePage()),
    go: uri => dispatch(pushWithQueryParams(uri)),
    push: uri => dispatch(push(uri)),
    goBack: () => dispatch(goBack()),
    openShippingForm: () =>
      dispatch(
        modal.openModal({
          modalType: "SHIPPING_FORM",
          modalProps: {}
        })
      ),
    menuSwitch: () => dispatch(menu.menuSwitch()),
    closeMenu: () => dispatch(menu.menuOff()),
    openLoginForm: () =>
      dispatch(
        modal.openModal({
          modalType: "LOGIN_FORM",
          modalProps: {
              raisedClass: 'raise'
          }
        })
      ),
    openLogOutForm: props =>
      dispatch(
        modal.openModal({
          modalType: "LOGOUT_FORM",
          modalProps: props
        })
      ),
    openSignUpForm: () =>
      dispatch(
        modal.openModal({
          modalType: "SIGNUP_FORM",
          modalProps: {}
        })
      ),
    openHelp: () =>
      dispatch(
        modal.openModal({
          modalType: "HELP_PAGE",
          modalProps: {}
        })
      ),
    openOrders: () =>
      dispatch(
        modal.openModal({
          modalType: "ORDERS_PAGE",
          modalProps: {}
        })
      ),
    openAccount: () =>
      dispatch(
        modal.openModal({
          modalType: "MY_ACCOUNT_PAGE",
          modalProps: {}
        })
      ),
    openNotifications: props =>
      dispatch(
        modal.openModal({
          modalType: "NOTIFICATIONS_PAGE",
          modalProps: {}
        })
      ),
    openAddresses: props =>
      dispatch(
        page.openPage({
          pageType: "ADDRESSES_PAGE",
          pageProps: {}
        })
      ),
    openFilter: () => dispatch(pushWithQueryParams(filterUri)),
    hideDetail: () => dispatch({ type: "HIDE_DETAIL_VIEW" }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);

const ItemTitleSpanStyled = styled.span`
  font-weight: 400;
  font-size: 14px;
  opacity: ${props => (props.disabled ? 0.3 : 1.0)};
`;



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.jsx